export const PaymentGuestComponent = {
    template: `
        <oo-card>
            <oo-card-header>
                <p>Payment</p>
            </oo-card-header>

            <oo-card-body>
                <div class="column column-sm-12 expand">
                    <payment-method></payment-method>
                </div>
                <div class="column column-sm-12 expand fold-animation" ng-if="$ctrl.shouldShowCash()">
                    <cash></cash>
                </div>
                <div class="column column-sm-12 expand fold-animation" ng-if="$ctrl.shouldShowCard()">
                    <add-credit-card></add-credit-card>
                    <oo-tip ng-if="$ctrl.tipEnabled"></oo-tip>
                </div>
        </oo-card>
    `,
    controller: class {
        constructor(paymentService, restaurantInfoFactory) {
            'ngInject';
            this.paymentService = paymentService;
            this.restaurantInfoFactory = restaurantInfoFactory;
        }

        $onInit() {
            this.paymentService.initialize();
            this.restaurantInfoFactory.getInfo(['info'])
                .then(info => this.tipEnabled = info.onlineOrder.paymentOptions.ccTipEnabled);

        }

        shouldShowCash() {
            return this.paymentService.data.cashPayment &&
                this.paymentService.data.selectedPayment.method === 'CASH';
        }

        shouldShowCard() {
            return this.paymentService.data.cardPayment &&
                this.paymentService.data.selectedPayment.method === 'CREDIT';
        }

    }
};
